/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignPlatformSchema,
  countResponseSchema,
} from '../campaign-schema';

export const getPendingCreatorsCountPathSchema = z.object({
  campaignId: z.string(),
});

export const getPendingCreatorsCountQuerySchema = z.object({
  platform: campaignPlatformSchema.optional(),
  name: z.string().optional(),
  label: z.string().optional(),
});

export const getPendingCreatorsCountOperationResponseSchema =
  countResponseSchema;

export type GetPendingCreatorsCountInput = {
  path: z.input<typeof getPendingCreatorsCountPathSchema>;
  query?: z.input<typeof getPendingCreatorsCountQuerySchema>;
  signal?: AbortSignal;
};

export async function getPendingCreatorsCount({
  path,
  query,
  signal,
}: GetPendingCreatorsCountInput): Promise<
  z.infer<typeof getPendingCreatorsCountOperationResponseSchema>
> {
  const parsedPath = getPendingCreatorsCountPathSchema.parse(path);
  const parsedQuery = getPendingCreatorsCountQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/pending_creators/count`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return getPendingCreatorsCountOperationResponseSchema.parse(
    await response.json(),
  );
}
